import React from 'react';
import styled from 'styled-components';
import Left from '@material-ui/icons/ArrowLeft';
import Right from '@material-ui/icons/ArrowRight';
import { Link } from 'react-router-dom';
const LinkToPhase = styled(Link)`
  text-decoration: none;
  color: initial;
`;

const Navigator = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  max-width: 1024px;
  width: 100%;
`;
const LeftRight = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

class NavigateBar extends React.Component {
  navigate = where => () => {
    let i = this.props.slipIds.indexOf(this.props.slipId);
    let id;
    if (where === 'next') {
      i = i + 1; // increase i by one
      i = i % this.props.slipIds.length; // if we've gone too high, start from `0` again
      id = this.props.slipIds[i]; // give us back the item of where we are now
      this.props.history.push(
        `/demand/project/${this.props.projectId}/ticket/${this.props.ticketId}/slip/${id}`
      );
      this.props.getIt(id);
    } else {
      if (i === 0) {
        // i would become 0
        i = this.props.slipIds.length; // so put it at the other end of the array
      }
      i = i - 1; // decrease by one
      id = this.props.slipIds[i]; // give us back the item of where we are now
      this.props.history.push(
        `/demand/project/${this.props.projectId}/ticket/${this.props.ticketId}/slip/${id}`
      );
      this.props.getIt(id);
    }
  };

  render() {
    return (
      <Navigator>
        <LeftRight onClick={this.navigate('prev')}>
          <Left />
          Previous luminaire
        </LeftRight>
        <LeftRight onClick={this.navigate('next')}>
          Next luminaire
          <Right />
        </LeftRight>
      </Navigator>
    );
  }
}
export default NavigateBar;
